/* ============================================================
   SLOPE FACES, Face Picker / Bundle Builder
   ------------------------------------------------------------
   Aufbau der rechten Spalte, von oben nach unten:

     Buy-Box-Kopf (aus Liquid)  Titel, Preis, USPs
     Face-Leiste                alle Gesichter, horizontal scrollbar
     Urgency-Zeile              nur wenn gesetzt
     Pack-Zeilen                1 / 2 / 3 / 6 als Radio-Karten
       darin, wenn gewählt:     ein Dropdown je Platz im Pack
     Add to Cart

   Zwei Regeln, die den Aufbau erklären:

   1. Preise werden hier NIE gerechnet. Shopify besitzt den Preis.
      Die Strings in der Config sind reine Anzeige. Der Rabatt
      wird von Shopify durchgesetzt, siehe README "Pricing".

   2. Leere Werte rendern nichts. Keine Platzhalter-Bewertung,
      keine erfundene Verknappung. Was leer ist, bleibt weg.
   ============================================================ */

(function () {
  'use strict';

  var CFG  = window.SLOPE_FACES_CONFIG;
  var COPY = CFG.copy || {};

  /* ==========================================================
     PLATZHALTER
     Ein Face ohne echtes Bild bekommt eine sichtbar unfertige
     Grafik, damit Entwicklung nie an fehlenden Assets hängt.
     ========================================================== */

  function placeholder(name, kind) {
    var worn = kind === 'worn';
    var w = worn ? 800 : 220, h = w, fs = worn ? 34 : 15;

    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '" viewBox="0 0 ' + w + ' ' + h + '">' +
        '<rect width="100%" height="100%" fill="#F6F7F9"/>' +
        '<rect x="6" y="6" width="' + (w - 12) + '" height="' + (h - 12) + '" fill="none" ' +
          'stroke="#C9CED6" stroke-width="3" stroke-dasharray="12 9" rx="' + (worn ? 22 : 12) + '"/>' +
        '<g transform="translate(' + (w / 2) + ',' + (h * 0.42) + ')">' +
          '<ellipse rx="' + (w * 0.24) + '" ry="' + (w * 0.29) + '" fill="#DDE2E8"/>' +
          '<rect x="' + (-w * 0.25) + '" y="' + (-w * 0.11) + '" width="' + (w * 0.50) + '" height="' + (w * 0.16) + '" rx="' + (w * 0.07) + '" fill="#1692FD"/>' +
        '</g>' +
        '<text x="50%" y="' + (h * 0.80) + '" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" ' +
          'font-weight="bold" font-size="' + fs + '" fill="#121212">' + esc(name.toUpperCase()) + '</text>' +
      '</svg>';

    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;');
  }

  function thumbOf(f) { return f.thumbnail   || placeholder(f.name, 'thumb'); }
  function wornOf(f)  { return f.wornPreview || placeholder(f.name, 'worn');  }

  /* Preis-Strings sind Anzeige. Für "Save X%" brauchen wir eine
     Zahl, deshalb hier geparst, nirgends sonst gerechnet. */
  function num(s) {
    if (!s) return null;
    var v = parseFloat(String(s).replace(/[^0-9.]/g, ''));
    return isNaN(v) ? null : v;
  }

  function savePct(p) {
    /* Liefert Liquid den Prozentwert mit, gilt der. Er stammt aus
       derselben Zahl wie der berechnete Preis und ist damit auch
       in umgerechneten Währungen korrekt. Aus formatierten
       Beträgen zurückzurechnen wäre bei Tausendertrennzeichen und
       fremden Währungssymbolen fehleranfällig. */
    if (typeof p.save === 'number' && p.save > 0) return p.save;

    var now = num(p.price), was = num(p.compareAt);
    if (now === null || was === null || was <= 0 || now >= was) return null;
    return Math.round((1 - now / was) * 100);
  }

  /* ==========================================================
     RÜCKMELDUNG NACH DEM HINZUFÜGEN
     Ohne sichtbare Reaktion wirkt der Kaufbutton kaputt, auch
     wenn der Warenkorb längst gefüllt ist. Genau das ist
     passiert. Drei Stufen, von der besten zur gröbsten:
     Drawer mit frischem Inhalt, Drawer ohne, Weiterleitung.
     ========================================================== */

  function revealCart(res) {
    var drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.renderContents === 'function' && res && res.sections) {
      try {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
        return;
      } catch (e) { /* weiter zur nächsten Stufe */ }
    }

    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch (e) { /* weiter */ }
    }

    window.location.href = '/cart';
  }

  /* ==========================================================
     COMMERCE ADAPTER, die einzige Naht zu Shopify
     ========================================================== */

  var CommerceAdapter = {

    mock: {
      getAvailability: function () {
        return Promise.resolve(Object.assign({}, CFG.commerce.mockAvailability || {}));
      },
      addToCart: function (lines) {
        window.alert(
          'MOCK CART, nothing was really added.\n\n' +
          lines.map(function (l) { return l.name + ' x' + l.quantity; }).join('\n')
        );
        return Promise.resolve({ ok: true });
      }
    },

    shopify: {
      getAvailability: function () {
        return fetch(window.location.pathname + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var map = {};
            CFG.faces.forEach(function (face) {
              var v = product.variants.filter(function (x) { return x.id === face.variantId; })[0];
              map[face.id] = !!(v && v.available);
            });
            return map;
          });
      },
      addToCart: function (lines) {
        var drawer = document.querySelector('cart-drawer');

        /* Shrine rendert den Warenkorb-Drawer aus Section-HTML.
           Fordert man die Sections gleich beim Hinzufügen mit an,
           lässt sich der Drawer ohne zweiten Request füllen. */
        var sections = [];
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          try {
            sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          } catch (e) { sections = []; }
        }

        var payload = {
          items: lines.map(function (l) {
            return {
              id: l.variantId,
              quantity: l.quantity,
              properties: { _pack: l.packSize + '-face-pack' }
            };
          })
        };
        if (sections.length) {
          payload.sections = sections;
          payload.sections_url = window.location.pathname;
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (!r.ok) throw new Error('cart/add failed');
          return r.json();
        }).then(function (res) {
          revealCart(res);
          return res;
        });
      }
    },

    get current() { return this[CFG.commerce.mode] || this.mock; }
  };

  /* ==========================================================
     ZUSTAND
     `slots` ist eine Liste mit einem Face je Platz im Pack.
     Sie ist immer vollständig gefüllt. Dadurch gibt es keine
     halbfertigen Zustände und keinen gesperrten Kaufbutton.
     ========================================================== */

  var state = {
    packSize: (CFG.packs.filter(function (p) { return p.recommended; })[0] || CFG.packs[0] || { size: 1 }).size,
    slots: [],
    activeFaceId: CFG.faces[0] ? CFG.faces[0].id : null,
    availability: {},
    busy: false,
    error: ''
  };

  function face(id) { return CFG.faces.filter(function (f) { return f.id === id; })[0]; }
  function isAvailable(id) { return state.availability[id] !== false; }
  function pack(size) { return CFG.packs.filter(function (p) { return p.size === size; })[0]; }

  function availableFaces() {
    return CFG.faces.filter(function (f) { return isAvailable(f.id); });
  }

  /* Vorbelegung: der Reihe nach verschiedene Gesichter. Das zeigt
     sofort, worum es geht, und man muss nichts tun, um kaufen zu
     können. Ändern kann man jeden Platz einzeln. */
  function fillSlots() {
    var pool = availableFaces();
    if (!pool.length) pool = CFG.faces;
    var out = [];
    for (var i = 0; i < state.packSize; i++) {
      out.push(state.slots[i] && pool.some(function (f) { return f.id === state.slots[i]; })
        ? state.slots[i]
        : (pool[i % pool.length] || {}).id);
    }
    state.slots = out;
  }

  function t(key, vars) {
    var s = COPY[key] || '';
    Object.keys(vars || {}).forEach(function (k) {
      s = s.replace(new RegExp('\\{' + k + '\\}', 'g'), vars[k]);
    });
    return s;
  }

  /* ==========================================================
     AKTIONEN
     ========================================================== */

  function setPack(size) {
    state.packSize = size;
    state.error = '';
    fillSlots();
    render();
  }

  /* Nur Vorschau. Verändert die Auswahl bewusst nicht. */
  function setActive(id) {
    state.activeFaceId = id;
    renderPreview();
    renderMediaNav();
    renderStrip();
  }

  function setSlot(i, id) {
    state.slots[i] = id;
    state.activeFaceId = id;     // Mockup springt auf das gewählte Gesicht
    state.error = '';
    renderPreview();
    renderMediaNav();
    renderStrip();
    renderSlotThumbs();
    renderCta();
  }

  function cartLines() {
    var byFace = {};
    state.slots.forEach(function (id) { byFace[id] = (byFace[id] || 0) + 1; });
    return Object.keys(byFace).map(function (id) {
      var f = face(id) || {};
      return { faceId: id, name: f.name, variantId: f.variantId,
               quantity: byFace[id], packSize: state.packSize };
    });
  }

  function addToCart() {
    if (state.busy) return;
    state.busy = true;
    state.error = '';
    renderCta();

    CommerceAdapter.current.getAvailability()
      .then(function (avail) {
        state.availability = avail;
        var gone = state.slots.filter(function (id) { return avail[id] === false; });
        if (gone.length) throw new Error(COPY.unavailableError || 'One of your faces just sold out. Swap it to continue.');
        return CommerceAdapter.current.addToCart(cartLines());
      })
      .then(function () {
        state.busy = false;
        render();
        document.dispatchEvent(new CustomEvent('slopefaces:added'));
      })
      .catch(function (err) {
        state.busy = false;
        state.error = err.message || 'Something went wrong. Try again.';
        render();
      });
  }

  /* ==========================================================
     AUFBAU
     ========================================================== */

  var el = {};

  function mount(root) {
    /* Buy-Box-Kopf kommt serverseitig aus Liquid und wird hier
       oben in die rechte Spalte gehängt. */
    var headEl = root.querySelector('[data-sf-head]');
    var headHTML = headEl ? headEl.outerHTML : '';

    /* Fuß der Buy Box, ebenfalls serverseitig aus Liquid:
       Zahlungsarten und Trust-Zeilen. Beides muss unter den
       Kaufbutton, den dieses Skript erst erzeugt. */
    var footEl = root.querySelector('[data-sf-foot]');
    var footHTML = footEl ? footEl.outerHTML : '';

    root.innerHTML =
      '<div class="sf-grid">' +
        '<div class="sf-preview-col">' +
          '<div class="sf-preview" style="aspect-ratio:' + (CFG.previewRatio || '1 / 1') + '">' +
            '<img data-sf="previewImg" alt="">' +
            '<span class="sf-preview-name" data-sf="previewName"></span>' +
          '</div>' +
          '<div class="sf-media-nav" data-sf="mediaNav"></div>' +
        '</div>' +

        '<div class="sf-controls-col">' +
          headHTML +

          '<div class="sf-facestrip-head">' +
            '<span class="sf-facestrip-label">Face:</span> ' +
            '<b data-sf="stripName"></b>' +
          '</div>' +
          '<ul class="sf-facestrip" data-sf="strip"></ul>' +

          '<div class="sf-urgency" data-sf="urgency" hidden></div>' +

          '<div class="sf-packlist" data-sf="packs"></div>' +

          '<div class="sf-error" data-sf="error" hidden></div>' +

          '<button class="sf-cta" data-sf="cta" type="button"></button>' +
          '<p class="sf-cta-note" data-sf="ctaNote"></p>' +
          footHTML +
        '</div>' +
      '</div>';

    ['previewImg','previewName','mediaNav','strip','stripName','urgency','packs','error','cta','ctaNote']
      .forEach(function (k) { el[k] = root.querySelector('[data-sf="' + k + '"]'); });

    if (headEl) root.querySelector('[data-sf-head]').hidden = false;
    if (footEl) root.querySelector('[data-sf-foot]').hidden = false;
    el.headPrice = root.querySelector('[data-sf="headPrice"]');

    el.cta.addEventListener('click', addToCart);

    var previewNode = root.querySelector('.sf-preview');
    if (previewNode) enableSwipe(previewNode);

    /* Keine Sticky Buy Bar. Auf Wunsch entfernt, 2026-10-09. */

    /* Die CSS-Reservierung hat bis hierher den Platz freigehalten,
       damit die Seite beim Mounten nicht springt. Jetzt zählt die
       echte Höhe, sonst bliebe unten ein leerer Rest stehen. */
    root.classList.add('is-mounted');
  }

  /* ==========================================================
     MEDIEN
     ========================================================== */

  function faceIndex() {
    for (var i = 0; i < CFG.faces.length; i++) {
      if (CFG.faces[i].id === state.activeFaceId) return i;
    }
    return 0;
  }

  function step(delta) {
    var n = CFG.faces.length;
    if (!n) return;
    setActive(CFG.faces[(faceIndex() + delta + n) % n].id);
  }

  var CHEV = {
    left:  '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 4 7 12l8 8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    right: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M9 4l8 8-8 8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function renderPreview() {
    var f = face(state.activeFaceId) || CFG.faces[0];
    if (!f || !el.previewImg) return;
    el.previewImg.src = wornOf(f);
    el.previewImg.alt = f.name + ' ski balaclava worn with goggles';
    el.previewName.textContent = f.name;
    if (el.stripName) el.stripName.textContent = f.name;
  }

  function renderMediaNav() {
    if (!el.mediaNav) return;
    var n = CFG.faces.length;
    if (n < 2) { el.mediaNav.innerHTML = ''; return; }

    el.mediaNav.innerHTML =
      '<button class="sf-media-arrow" type="button" data-step="-1" aria-label="Previous image">' + CHEV.left + '</button>' +
      '<span class="sf-media-count">' + (faceIndex() + 1) + '/' + n + '</span>' +
      '<button class="sf-media-arrow" type="button" data-step="1" aria-label="Next image">' + CHEV.right + '</button>';

    Array.prototype.forEach.call(el.mediaNav.querySelectorAll('[data-step]'), function (btn) {
      btn.addEventListener('click', function () { step(Number(btn.dataset.step)); });
    });
  }

  function enableSwipe(node) {
    var x0 = null, y0 = null;
    node.addEventListener('touchstart', function (e) {
      x0 = e.changedTouches[0].clientX; y0 = e.changedTouches[0].clientY;
    }, { passive: true });
    node.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      /* Nur klar horizontale Gesten, sonst kapern wir das Scrollen. */
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.6) step(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ==========================================================
     FACE-LEISTE
     Horizontal scrollbar, weil weitere Gesichter dazukommen.
     Antippen wechselt nur die Vorschau, nicht die Auswahl.
     ========================================================== */

  function renderStrip() {
    if (!el.strip) return;

    el.strip.innerHTML = CFG.faces.map(function (f, i) {
      var active = f.id === state.activeFaceId;
      var sold = !isAvailable(f.id);
      /* Die ersten vier Kacheln sind beim Laden sichtbar. Lazy
         geladen poppen sie leer auf und sehen nach Fehler aus. */
      var loading = i < 6 ? 'eager' : 'lazy';
      return '<li class="sf-facetile' + (active ? ' is-active' : '') + (sold ? ' is-soldout' : '') + '">' +
          '<button type="button" data-tile="' + esc(f.id) + '" aria-pressed="' + active + '">' +
            '<img src="' + thumbOf(f) + '" alt="" loading="' + loading + '" width="92" height="92">' +
            '<span class="sf-facetile-name">' + esc(f.name) + '</span>' +
            (sold ? '<span class="sf-facetile-sold">Sold out</span>' : '') +
          '</button>' +
        '</li>';
    }).join('');

    Array.prototype.forEach.call(el.strip.querySelectorAll('[data-tile]'), function (btn) {
      btn.addEventListener('click', function () { setActive(btn.dataset.tile); });
    });
  }

  function renderUrgency() {
    if (!el.urgency) return;
    var line = (CFG.urgency && CFG.urgency.announcement) || '';
    el.urgency.hidden = !line;
    el.urgency.innerHTML = line ? '<span>' + esc(line) + '</span>' : '';
  }

  /* ==========================================================
     PACK-ZEILEN
     Radio-Karten. Die gewählte klappt auf und zeigt je Platz
     ein Dropdown mit kleinem Gesicht davor.
     ========================================================== */

  function slotOptions(selectedId) {
    return CFG.faces.map(function (f) {
      var sold = !isAvailable(f.id);
      return '<option value="' + esc(f.id) + '"' +
             (f.id === selectedId ? ' selected' : '') +
             (sold ? ' disabled' : '') + '>' +
             esc(f.name) + (sold ? ' (sold out)' : '') +
             '</option>';
    }).join('');
  }

  function renderPacks() {
    if (!el.packs) return;

    el.packs.innerHTML = CFG.packs.map(function (p) {
      var on = p.size === state.packSize;
      var pct = savePct(p);

      var slots = '';
      if (on) {
        var rows = '';
        for (var i = 0; i < state.packSize; i++) {
          var fid = state.slots[i];
          var f = face(fid) || CFG.faces[0] || {};
          rows +=
            '<li class="sf-slot">' +
              '<img class="sf-slot-thumb" data-slotthumb="' + i + '" src="' + thumbOf(f) + '" alt="">' +
              '<div class="sf-slot-select">' +
                '<select data-slot="' + i + '" aria-label="Face ' + (i + 1) + ' of ' + state.packSize + '">' +
                  slotOptions(fid) +
                '</select>' +
              '</div>' +
            '</li>';
        }
        slots =
          '<div class="sf-slots">' +
            '<p class="sf-slots-title">Pick your ' + state.packSize + ' ' + (state.packSize === 1 ? 'face' : 'faces') + '</p>' +
            '<ul class="sf-slotlist">' + rows + '</ul>' +
          '</div>';
      }

      return '<div class="sf-packcard' + (on ? ' is-selected' : '') + (p.badge ? ' has-badge' : '') + '">' +
          /* Badge sitzt an der Karte, nicht im Text. Nur so kann
             es als Fähnchen oben rechts aus der Kante ragen. */
          (p.badge ? '<span class="sf-packrow-badge">' + esc(p.badge) + '</span>' : '') +
          '<label class="sf-packrow">' +
            '<input type="radio" name="sf-pack" value="' + p.size + '"' + (on ? ' checked' : '') + '>' +
            '<span class="sf-packrow-body">' +
              '<span class="sf-packrow-left">' +
                '<span class="sf-packrow-title">' + p.size + ' ' + (p.size === 1 ? 'Face' : 'Faces') + '</span>' +
                (p.perFace && p.size > 1 ? '<span class="sf-packrow-per">' + esc(p.perFace) + ' / face</span>' : '') +
                /* Ersparnis und Zugabe stehen links unter dem Preis
                   pro Face. Rechts konkurrierten sie vorher mit
                   Preis und Streichpreis um dieselbe Ecke. */
                ((pct || p.perk) ?
                  '<span class="sf-packrow-perks">' +
                    (pct ? '<span class="sf-packrow-save">Save ' + pct + '%</span>' : '') +
                    (p.perk ? '<span class="sf-packrow-perk">' + esc(p.perk) + '</span>' : '') +
                  '</span>' : '') +
              '</span>' +
              '<span class="sf-packrow-right">' +
                (p.price ? '<span class="sf-packrow-now">' + esc(p.price) + '</span>' : '') +
                (p.compareAt ? '<s class="sf-packrow-was">' + esc(p.compareAt) + '</s>' : '') +
              '</span>' +
            '</span>' +
          '</label>' +
          slots +
        '</div>';
    }).join('');

    Array.prototype.forEach.call(el.packs.querySelectorAll('input[name="sf-pack"]'), function (input) {
      input.addEventListener('change', function () { setPack(Number(input.value)); });
    });

    Array.prototype.forEach.call(el.packs.querySelectorAll('[data-slot]'), function (sel) {
      sel.addEventListener('change', function () { setSlot(Number(sel.dataset.slot), sel.value); });
    });
  }

  /* Nach einer Dropdown-Änderung nur die Bildchen nachziehen.
     Ein kompletter Neuaufbau würde den Fokus aus dem Select
     reißen und auf dem Handy die Liste wegspringen lassen. */
  function renderSlotThumbs() {
    if (!el.packs) return;
    Array.prototype.forEach.call(el.packs.querySelectorAll('[data-slotthumb]'), function (img) {
      var f = face(state.slots[Number(img.dataset.slotthumb)]);
      if (f) img.src = thumbOf(f);
    });
  }

  function renderHeadPrice() {
    if (!el.headPrice) return;
    var p = pack(state.packSize);
    if (!p || !p.price) { el.headPrice.innerHTML = ''; return; }
    var pct = savePct(p);
    el.headPrice.innerHTML =
      '<span class="sf-price-now">' + esc(p.price) + '</span>' +
      (p.compareAt ? '<s class="sf-price-was">' + esc(p.compareAt) + '</s>' : '') +
      (pct ? '<span class="sf-price-per">Save ' + pct + '%</span>' : '');
  }

  function renderCta() {
    var n = state.packSize;
    var soldInSlots = state.slots.some(function (id) { return !isAvailable(id); });

    var label = state.busy ? 'Adding…'
      : soldInSlots ? 'Swap your sold out face'
      : (n === 1 ? (COPY.ctaReadySingle || 'Get my face') : t('ctaReady', { total: n }) + ' →');

    el.cta.textContent = label;
    el.cta.disabled = state.busy || soldInSlots;

    el.ctaNote.textContent = CFG.commerce.mode === 'mock'
      ? 'Demo mode. No real cart connected yet.' : '';

    el.error.hidden = !state.error;
    el.error.textContent = state.error;
  }

  function render() {
    renderPreview();
    renderMediaNav();
    renderStrip();
    renderUrgency();
    renderPacks();
    renderHeadPrice();
    renderCta();
  }

  function scrollToPicker() {
    var node = document.querySelector('[data-slope-faces]');
    if (node) node.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ==========================================================
     START
     ========================================================== */

  function init() {
    var root = document.querySelector('[data-slope-faces]');
    if (!root || !CFG || !CFG.faces || !CFG.faces.length) return;

    mount(root);
    fillSlots();
    render();

    CommerceAdapter.current.getAvailability().then(function (avail) {
      state.availability = avail;
      if (!isAvailable(state.activeFaceId)) {
        var ok = availableFaces()[0];
        if (ok) state.activeFaceId = ok.id;
      }
      /* Ausverkaufte Gesichter aus der Vorbelegung werfen. */
      state.slots = state.slots.map(function (id) {
        if (isAvailable(id)) return id;
        var ok = availableFaces()[0];
        return ok ? ok.id : id;
      });
      render();
    });
  }

  window.SlopeFacesPicker = { scrollTo: scrollToPicker };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
